import { INITIALIZE_FORM } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default (values) => companyGeneralActions[INITIALIZE_FORM](values);
